import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import { Formik } from 'formik';

import CashbackPresenter from '../../../../../../../presenters/CashbackPresenter';
import {
  validationSchema,
  initialValues,
} from '../../../../../../../forms/cashback/editForm';
import Modal from '../../../../../../../components/Modal';
import Flash from '../../../../../../../components/forms/Flash';

import EditCashbackForm from './components/EditCashbackForm';

const EditCashbackModal = (props) => {
  const {
    onEditCashbackModalClose,
    cashbackParams,
    isEditDialogOpen,
    onSubmit,
    errors,
  } = props;

  return (
    <Modal
      title="Edit Cashback"
      onClose={onEditCashbackModalClose}
      isModalOpen={isEditDialogOpen}
    >
      {!isNil(errors) && <Flash response={errors} />}

      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => onSubmit(values, actions)}
        initialValues={initialValues(cashbackParams)}
        validationSchema={validationSchema}
        render={(formikProps) => (
          <EditCashbackForm
            {...formikProps}
            onModalClose={onEditCashbackModalClose}
          />
        )}
      />
    </Modal>
  );
};

export default EditCashbackModal;

EditCashbackModal.propTypes = {
  onEditCashbackModalClose: PropTypes.func.isRequired,
  isEditDialogOpen: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  cashbackParams: CashbackPresenter.shape().isRequired,
  errors: PropTypes.shape(),
};

EditCashbackModal.defaultProps = {
  errors: {},
};
